import { getErrorReason, suppressableOperations, tableNotFoundError } from './getErrorReason.ts';

export const shouldSuppressSnackbar = ({ operationName }, response) =>
  suppressableOperations.includes(operationName) && getErrorReason(response?.errors) === tableNotFoundError;
